import type { Option } from '@vaaas/fpts/option';
import type { IFrontendServiceContainer } from './service-container';
import { inject } from 'vue';

export const SERVICE_CONTAINER = 'service-container';

class InjectionNotProvided extends Error {
    constructor(injection: string) {
        super('Injection was not provided: ' + injection);
    }
}

const injectOrThrow = <T>(injection: string): T => {
    const x = inject(injection) as Option<T>;
    if (!x)
        throw new InjectionNotProvided(injection);
    else
        return x;
};

export const useServiceContainer = () => injectOrThrow<IFrontendServiceContainer>(SERVICE_CONTAINER);
